import type { LucideIcon } from 'lucide-react';
import {
  Camera,
  ChevronDown,
  Gamepad2,
  Headphones,
  Laptop,
  Package,
  Smartphone,
  Watch,
} from 'lucide-react';
import type { BannerSlideDisplay } from '../../types/slider';

export const heroSlides: BannerSlideDisplay[] = [
  {
    id: 'hero-1',
    subtitle: 'brixECOM',
    title: 'New trending Electronic items',
    cta: 'Learn more',
    ctaHref: '#deals',
    image: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=600&h=400&fit=crop',
    imageAlt: 'Trending smartphones',
    variant: 'hero',
  },
  {
    id: 'hero-2',
    subtitle: 'Limited time',
    title: 'Premium Laptops up to 30% off',
    cta: 'Shop laptops',
    ctaHref: '#deals',
    image: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=600&h=400&fit=crop',
    imageAlt: 'Laptops on sale',
    bgClass: 'bg-gradient-to-br from-neutral-100 via-white to-red-50',
    variant: 'hero',
  },
  {
    id: 'hero-3',
    subtitle: 'Audio week',
    title: 'Smart Audio & Headphones collection',
    cta: 'Browse audio',
    ctaHref: '#deals',
    image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=600&h=400&fit=crop',
    imageAlt: 'Headphones collection',
    bgClass: 'bg-gradient-to-br from-red-50/80 via-white to-neutral-50',
    variant: 'hero',
  },
];

export const sidebarCategories: { name: string; icon: LucideIcon }[] = [
  { name: 'Smartphones', icon: Smartphone },
  { name: 'Laptops & PCs', icon: Laptop },
  { name: 'Audio & Headphones', icon: Headphones },
  { name: 'Smart Watches', icon: Watch },
  { name: 'Cameras', icon: Camera },
  { name: 'Gaming', icon: Gamepad2 },
  { name: 'Accessories', icon: Package },
  { name: 'More category', icon: ChevronDown },
];

export const navLinks = ['Hot offers', 'Services', 'Bestsellers', 'Gift boxes', 'Help'] as const;

export const dealProducts = [
  { name: 'Smartwatch Pro X', discount: 25, image: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=300&h=300&fit=crop' },
  { name: 'UltraBook X14', discount: 12, image: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=300&h=300&fit=crop' },
  { name: 'DSLR Camera Kit', discount: 30, image: 'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?w=300&h=300&fit=crop' },
  { name: 'Gaming Headset', discount: 18, image: 'https://images.unsplash.com/photo-1599669454699-248893623440?w=300&h=300&fit=crop' },
  { name: 'NovaPhone 15', discount: 22, image: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=300&h=300&fit=crop' },
];

export type ProductItem = { name: string; price: number; image: string };

export const homeProducts: ProductItem[] = [
  { name: 'Wireless Earbuds', price: 45, image: 'https://images.unsplash.com/photo-1590658268037-6bfaf65eda26?w=200&h=200&fit=crop' },
  { name: 'Bluetooth Speaker', price: 89, image: 'https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=200&h=200&fit=crop' },
  { name: 'Tablet Stand', price: 29, image: 'https://images.unsplash.com/photo-1585790050230-5dd284e3ff2f?w=200&h=200&fit=crop' },
  { name: 'USB-C Hub', price: 35, image: 'https://images.unsplash.com/photo-1625842268584-8f3296236761?w=200&h=200&fit=crop' },
  { name: 'Mechanical Keyboard', price: 120, image: 'https://images.unsplash.com/photo-1511467687858-23d96fa5e0e7?w=200&h=200&fit=crop' },
  { name: 'Wireless Mouse', price: 55, image: 'https://images.unsplash.com/photo-1527864554085-7d91d4da2f4e?w=200&h=200&fit=crop' },
  { name: 'Monitor 27"', price: 299, image: 'https://images.unsplash.com/photo-1527443224154-c4a3942d3acf?w=200&h=200&fit=crop' },
  { name: 'Webcam HD', price: 65, image: 'https://images.unsplash.com/photo-1587826080692-f439cd0b70de?w=200&h=200&fit=crop' },
];

export const electronicsProducts: ProductItem[] = [
  { name: 'Smart Watch Series 8', price: 249, image: 'https://images.unsplash.com/photo-1579586337278-3befd40fd17a?w=200&h=200&fit=crop' },
  { name: 'Noise Cancelling Buds', price: 149, image: 'https://images.unsplash.com/photo-1598331668826-20cecc596b86?w=200&h=200&fit=crop' },
  { name: 'Portable SSD 1TB', price: 89, image: 'https://images.unsplash.com/photo-1597872200963-2b35d8bd3227?w=200&h=200&fit=crop' },
  { name: 'Smart Home Hub', price: 79, image: 'https://images.unsplash.com/photo-1558089687-f282177bc369?w=200&h=200&fit=crop' },
  { name: 'Action Camera 4K', price: 199, image: 'https://images.unsplash.com/photo-1502920917128-1aa500764cbd?w=200&h=200&fit=crop' },
  { name: 'Electric Kettle Smart', price: 59, image: 'https://images.unsplash.com/photo-1564890369478-c89ca6d9cde9?w=200&h=200&fit=crop' },
  { name: 'Fitness Tracker', price: 39, image: 'https://images.unsplash.com/photo-1575311373937-040b8e1fd5b6?w=200&h=200&fit=crop' },
  { name: 'VR Headset', price: 349, image: 'https://images.unsplash.com/photo-1622979135225-d2fe269b5bd0?w=200&h=200&fit=crop' },
];

export const categorySections = [
  {
    title: 'Home and outdoor products',
    featureImage: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=500&h=600&fit=crop',
    products: homeProducts,
  },
  {
    title: 'Consumer electronics and gadgets',
    featureImage: 'https://images.unsplash.com/photo-1498049794561-7780e7231661?w=500&h=600&fit=crop',
    products: electronicsProducts,
  },
];
